import { selectBalancingBuff } from "../balancingSelectors/selectBalancingBuffs";
import { getResourceIconInfo } from "../features/generic/icon/getResourceIconInfo";
import { selectProductionResourceTotalBuffAmount } from "./selectBuffsInfo";
import { selectRecipeInfo } from "./selectRecipeInfo";
export var selectBuffProductPellet = function (state, product, buffFactorAddiction) {
    var buffedPellet = getResourceIconInfo(product);
    buffedPellet.amount = selectProductionResourceTotalBuffAmount(state, product.typeId, product.amount, buffFactorAddiction);
    return buffedPellet;
};
export var selectBuffFactorAddition = function (state, building) {
    var hasBooster = building.production &&
        building.production.production &&
        building.production.production.boosterId;
    if (hasBooster) {
        var buffedRecipe = selectRecipeInfo(state, building.production.production.boosterId);
        var buff = buffedRecipe && buffedRecipe.recipe.buffId
            ? selectBalancingBuff(buffedRecipe.recipe.buffId)
            : undefined;
        if (buff && buff.factorAddition) {
            return buff.factorAddition;
        }
    }
    return 0;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectProduction.ts
// module id = 818
// module chunks = 3